import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ca7c21ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7c21ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca7c21ca')) {
      api.createRecord('ca7c21ca', component.options)
    } else {
      api.reload('ca7c21ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ca7c21ca&scoped=true", function () {
      api.rerender('ca7c21ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/WMS/NSTD/index.vue"
export default component.exports